import { loader } from 'graphql.macro';

export const GET_PARTNER_AGENCIES_QUERY = loader(
  './getPartnerAgencies.graphql'
);
export const GET_PARTNER_CHANNEL_COMMISSION = loader(
  './getPartnerChannelCommissionStructure.graphql'
);
export const GET_PARTNER_COMPLIANCE = loader('./getPartnerCompliance.graphql');
export const UPDATE_STATE_AUTHORIZATIONS = loader(
  './updateStateAuthorizationsMutation.graphql'
);

export const CREATE_PARTNER = loader('./createPartnerMutation.graphql');
export const CREATE_GRANTS = loader('./createPartnerGrantMutation.graphql');
export const DELETE_GRANTS = loader('./deletePartnerGrantMutation.graphql');
export const UPDATE_PARTNER = loader('./updatePartnerMutation.graphql');
export const GET_PARTNER_USERS_QUERY = loader('./getPartnerUsers.graphql');
export const UPDATE_PARTNER_PERMISSION = loader(
  './updatePartnerPermissionMutation.graphql'
);
export const GET_PARTNERS_QUERY = loader('./getPartners.graphql');
export const GET_PARTNER_BY_ID = loader('./getPartnerById.graphql');

export const GET_MORATORIUM_EVENTS = loader('./getMoratoriumEvents.graphql');
export const GET_MORATORIUM_EVENT = loader('./getMoratoriumEvent.graphql');

export const UPDATE_MORATORIUM_EVENT = loader(
  './updateMoratoriumEvent.graphql'
);
export const ACTIVATE_MORATORIUM_EVENT = loader(
  './activateMoratoriumEvent.graphql'
);
export const DEACTIVATE_MORATORIUM_EVENT = loader(
  './deactivateMoratoriumEvent.graphql'
);
export const ADD_POSTAL_CODE_TO_MORATORIUM_EVENT = loader(
  './addPostalCodeToMoratoriumEvent.graphql'
);
export const REMOVE_POSTAL_CODE_FROM_MORATORIUM_EVENT = loader(
  './removePostalCodeFromMoratoriumEvent.graphql'
);
export const CREATE_MORATORIUM_EVENT = loader(
  './createMoratoriumEvent.graphql'
);
